// extracted by mini-css-extract-plugin
export default {"userInformationColumn":"current-user-information-card_userInformationColumn__pgq5O"};